import { supabase } from '../supabaseClient';

/* Accès aux données « user_absences ». Chaque fonction renvoie la requête Supabase telle quelle
   (à attendre par l'appelant) : aucune logique métier ici. */

export function fetchUserAbsences(session) {
  return supabase.from('user_absences').select('*').eq('user_id', session?.user?.id).order('debut');
}

export function fetchAbsences() {
  return supabase.from('user_absences').select('*').order('debut').order('id');
}

// absence : { userId, devId, type, debut, debut_half, fin, fin_half, statut }. Saisie pour
// quelqu'un d'autre (decidedBy) : la décision est enregistrée en même temps.
export function insertAbsence(
  { userId, devId, type, debut, debut_half, fin, fin_half, statut },
  decidedBy,
) {
  return supabase
    .from('user_absences')
    .insert({
      user_id: userId,
      dev_id: devId,
      type,
      debut,
      fin,
      debut_half,
      fin_half,
      statut,
      ...(decidedBy ? { decided_by: decidedBy, decided_at: new Date().toISOString() } : {}),
    })
    .select()
    .single();
}

export function saveAbsenceDecision(absence, session, statut) {
  return supabase
    .from('user_absences')
    .update({ statut, decided_by: session.user.id, decided_at: new Date().toISOString() })
    .eq('id', absence.id)
    .select()
    .single();
}

export function deleteAbsence(absence) {
  return supabase.from('user_absences').delete().eq('id', absence.id);
}

export function saveAbsenceChanges(oldAbsence, { type, debut, debut_half, fin, fin_half }) {
  return supabase
    .from('user_absences')
    .update({ type, debut, fin, debut_half, fin_half })
    .eq('id', oldAbsence.id)
    .select()
    .single();
}
